import cns from 'classnames';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import { slide as Slide } from 'react-burger-menu';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import LoadingIndicator from '../../../shared/components/LoadingIndicator';
import PathwayPanelWidget from '../../components/widgets/PathwayPanelWidget/PathwayPanelWidget';

const PanelWidget = (props) => {
    const config = useContext(RuntimeContext)
    const {
        currentWidth,
        columnHeight,
        homePageLoading,
        isHomePageLearningPanelOpen: isOpen = false,
        togglePanel,
        pathwaysEnabled,
        history,
        teamsById = {},
        pathwayView = '',
        userCompany,
        displayFeedbackModule,
        feedbackPanelExtended,
        pathwayPermalink
    } = props;

    const [userCompanyInState, setUserCompany] = useState({});
    const [animationClass, setAnimationClass] = useState('fadein');
    const [panelView, setPanelView] = useState('pathway');
    const [widerPane, setWiderPanel] = useState(false);
    const [finishedAllPathways, setFinishedAllPathways] = useState(false);
    const [panelLoadingOverlay, setPanelLoadingOverlay] = useState(false);

    useEffect(() => {
        setUserCompany(userCompany);
    }, [userCompany]);

    const components = {
        pathway: PathwayPanelWidget,
        loading: LoadingIndicator
    };

    const ActiveComponent = components[panelView];

    if (pathwayView !== 'detail' && widerPane) {
        setWiderPanel(false);
    }
    if (pathwayView === 'detail' && !widerPane) {
        setWiderPanel(true);
    }
    const isHomePageLearningPanelOpen = isOpen ?? true;
    const maxWidth = widerPane ? '960px' : '480px';

    return currentWidth > 450 ? (
        <>
            {!isHomePageLearningPanelOpen ? (
                <div className={'toggle-button-wrapper closed'}>
                    <div
                        className={cns(
                            'panel-hide-show-button',
                            { 'display-feedback-module': displayFeedbackModule },
                            { 'display-feedback-module-extended': feedbackPanelExtended }
                        )}
                        onClick={togglePanel}
                    >
                        <span
                            className={cns(
                                `fal ${
                                    !isHomePageLearningPanelOpen
                                        ? 'fa-chevron-right pathway-chevron-right'
                                        : 'fa-chevron-left pathway-chevron-left'
                                }`,
                                { 'fa-lg': true }
                            )}
                        ></span>
                    </div>
                </div>
            ) : null}
            <Slide
                styles={{ bmMenuWrap: { maxWidth, minHeight: columnHeight }, overflow: 'visible' }}
                outerContainerId={'home-page'}
                isOpen={!homePageLoading && isHomePageLearningPanelOpen}
                onClose={togglePanel}
                className={cns('home-panel-column', `panel-${panelView}`, {
                    'panel-shown': isHomePageLearningPanelOpen,
                    'panel-hidden': !isHomePageLearningPanelOpen || homePageLoading,
                    'expand-panel': widerPane
                })}
            >
                <>
                    <div className={'toggle-button-wrapper'}>
                        <div
                            className={cns(
                                'panel-hide-show-button',
                                { 'display-feedback-module': displayFeedbackModule },
                                { 'display-feedback-module-extended': feedbackPanelExtended }
                            )}
                            onClick={togglePanel}
                        >
                            <span
                                className={cns(
                                    `fal ${
                                        !isHomePageLearningPanelOpen
                                            ? 'fa-chevron-right pathway-chevron-right'
                                            : 'fa-chevron-left pathway-chevron-left'
                                    }`,
                                    { 'fa-lg': true }
                                )}
                            ></span>
                        </div>
                    </div>
                    <div className={cns(`col-12 home-panel ${panelView === 'loading' ? 'panel-loading-view' : ''}`)}>
                        {panelLoadingOverlay ? (
                            <div className={'pathway-panel-loading-overlay'}>
                                <LoadingIndicator />
                            </div>
                        ) : null}
                        <div className={cns(animationClass)}>
                            {!isEmpty(userCompanyInState) && (
                                <ActiveComponent
                                    {...props}
                                    isMobile={false}
                                    setWiderPanel={setWiderPanel}
                                    setAnimationClass={setAnimationClass}
                                    setPanelView={setPanelView}
                                    setFinishedAllPathways={setFinishedAllPathways}
                                    history={history}
                                    isPanel={true}
                                    finishedAllPathways={finishedAllPathways}
                                    setPanelLoadingOverlay={setPanelLoadingOverlay}
                                    userCompany={{ ...userCompanyInState }}
                                    pathwayPermalink={pathwayPermalink}
                                />
                            )}
                        </div>
                    </div>
                </>
            </Slide>
        </>
    ) : (
        <>
            {pathwaysEnabled ? (
                <div
                    className={`home-panel pathway-mobile-panel ${panelView === 'loading' ? 'panel-loading-view' : ''}`}
                >
                    {!isEmpty(userCompanyInState) && (
                        <PathwayPanelWidget
                            {...props}
                            isMobile={currentWidth < 450}
                            setWiderPanel={setWiderPanel}
                            setAnimationClass={setAnimationClass}
                            className={cns(animationClass)}
                            setPanelView={setPanelView}
                            setFinishedAllPathways={setFinishedAllPathways}
                            history={history}
                            finishedAllPathways={finishedAllPathways}
                            teamsById={teamsById}
                            userCompany={{ ...userCompanyInState }}
                            pathwayPermalink={pathwayPermalink}
                            setPanelLoadingOverlay={setPanelLoadingOverlay}
                        />
                    )}
                </div>
            ) : null}
        </>
    );
};

PanelWidget.propTypes = {
    currentWidth: PropTypes.number,
    columnHeight: PropTypes.string,
    isVerbAdmin: PropTypes.bool,
    homePageLoading: PropTypes.bool,
    isHomePageLearningPanelOpen: PropTypes.bool,
    togglePanel: PropTypes.func,
    pathwaysEnabled: PropTypes.bool,
    history: PropTypes.object,
    getManyUserCollections: PropTypes.func,
    teamsById: PropTypes.object,
    pathwayView: PropTypes.string,
    userCompany: PropTypes.object,
    displayFeedbackModule: PropTypes.bool,
    feedbackPanelExtended: PropTypes.bool,
    pathwayPermalink: PropTypes.string
};

export default PanelWidget;
